export const AMPLITUDE_EXPERIMENT_NAME = {
    TRADE_IN_CLP_REGO_CARD_VIEWED: "trade in CLP rego card viewed"
};

export const GA_EXPERIMENT_NAME = {
    CARD_VIEWED: "viewed",
    CAR_CARD_HOVER_VARIANT_ASSIGNED: "variant_assigned",
    CAR_CARD_HOVER_VARIANT_ASSIGNED_DATA: {
        event: "desktop_clp",
        eventCategory: "car_card_hover",
        eventAction: "variant_assigned"
    },
    GALLERY_ON_THE_FLY_DESKTOP: {
        event_category: "gallery_on_fly",
        event_action: "variant_assigned",
        event: "experiment"
    }
};
